// Shared helpers for error handlers to reduce duplication across modules

export function generateErrorId(prefix?: string): string {
  const timestamp = Date.now().toString(36).toUpperCase();
  const random = Math.random().toString(36).slice(2, 6).toUpperCase();
  return prefix ? `${prefix}-${timestamp}-${random}` : `${timestamp}-${random}`;
}

export function ensureRetry(msg: string): string {
  if (!msg) return 'Please try again.';
  return msg.includes('Please try again') ? msg : `${msg}. Please try again.`;
}

export function extractOriginalMessage(error: any): string {
  if (!error) return 'An unknown error occurred';
  if (typeof error === 'string') return error;
  if (error?.payload?.error) return error.payload.error;
  if (error?.payload?.message) return error.payload.message;
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.response?.data?.error) return error.response.data.error;
  if (error?.message) return error.message;
  return 'An unknown error occurred';
}
